import browser from "webextension-polyfill";
import { ytRecordEvent } from "../shared/index.js";
export async function recordEvent(eventName, eventPayload) {
    void browser.runtime.sendMessage({
        type: ytRecordEvent,
        eventName,
        eventPayload,
    });
}
